import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL =
  process.env.REACT_APP_BASE_URL || "https://backend.mystore.education/api";

// Helper function to get token
const getToken = () => {
  try {
    // Check localStorage first
    const localData = localStorage.getItem("loggedUser");
    if (localData) {
      const parsed = JSON.parse(localData);
      if (parsed.token) return parsed.token;
      if (parsed.data?.token) return parsed.data.token;
      if (parsed.result?.token) return parsed.result.token;
      if (parsed.user?.token) return parsed.user.token;
    }

    // Check sessionStorage
    const sessionData = sessionStorage.getItem("user");
    if (sessionData) {
      const parsed = JSON.parse(sessionData);
      if (parsed.token) return parsed.token;
      if (parsed.data?.token) return parsed.data.token;
      if (parsed.result?.token) return parsed.result.token;
      if (parsed.user?.token) return parsed.user.token;
    }

    return null;
  } catch (error) {
    console.error("Error getting token:", error);
    return null;
  }
};

// Fetch dashboard data
export const fetchDashboardData = createAsyncThunk(
  "dashboard/fetchDashboardData",
  async () => {
    try {
      const token = getToken();
      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await axios.get(`${BASE_URL}/dashboard/home`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Dashboard API Error:", error);
      throw error;
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    dashboardData: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearState: (state) => {
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch dashboard data
      .addCase(fetchDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardData = action.payload;
        state.error = null;
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearState } = dashboardSlice.actions;
export default dashboardSlice.reducer;
